var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMicChange = function SvgMicChange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "mic_change_svg__st0",
    d: "M4.3 4.7h3.5l4.7-2.8c.2-.1.4-.2.7-.1.2.1.4.3.4.5v10.1c0 .2-.1.4-.4.5-.2.1-.5.1-.7-.1L7.8 10H4.3c-.3 0-.6-.3-.6-.6V5.3c0-.3.2-.6.6-.6zM18.6 11.4l-.7-.7c1.9-1.9 1.9-4.9 0-6.8l.7-.7c2.3 2.3 2.3 5.9 0 8.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "mic_change_svg__st0",
    d: "m16.8 10.1-.7-.7c.5-.6.9-1.3.9-2.1s-.3-1.5-.9-2.1l.7-.7c.8.7 1.2 1.8 1.2 2.8 0 1-.4 2.1-1.2 2.8zM15.1 8.8l-.7-.7c.4-.4.4-1.1 0-1.6l.7-.7c.8.8.8 2.2 0 3zM9.4 17.9c-4.5-.6-7.8-2.9-7.8-5.4 0-.7.1-1.3.6-2l-.9-1.1c-.8 1-1.3 2.1-1.3 3.2 0 3.3 3.8 6.1 9.2 6.9h.1c.4 0 .7-.3.8-.7 0-.4-.3-.8-.7-.9zM24 12.6c0-1.2-.4-2.2-1.3-3.2l-.9 1.2c.6.7.7 1.2.7 1.9 0 2.4-3.3 4.7-7.7 5.3l1.8-1.5c.3-.3.4-.8.1-1.1-.3-.2-.7-.2-1.1 0l-3.7 3c-.2.2-.3.4-.3.6 0 .2.1.5.3.6l3.9 2.6c.1.1.3.1.4.1.2 0 .5-.1.6-.3.2-.4.1-.8-.2-1.1l-2-1.3c5.6-.7 9.4-3.5 9.4-6.8z"
  })));
};
export default SvgMicChange;